<template lang="html">
  <div>
    <v-form ref="creationApprovalLevelForm">
      <v-data-iterator
        :items="leaveTypes"
        :hide-default-footer="true"
        disable-pagination
        item-key="id"
      >
        <template>
          <v-row>
            <v-col
              v-for="(leaveType,index) in leaveTypes"
              :key="index"
              cols="12"
              md="6"
            >
              <v-card class="mx-4">
                <v-card-title style="padding-top:0;padding-bottom:0;margin:0">
                  <span class="title v-label theme--light pt-3">Leave Type: {{ leaveType.name }}</span>
                </v-card-title>

                <v-divider />
                <v-list
                  dense
                >
                  <v-list-item
                    class=""
                  >
                    <v-list-item-content
                      class="py-0"
                    >
                      Approval Level:
                    </v-list-item-content>
                    <v-text-field
                      v-model="leaveType.level"
                      :rules="[rules.required,rules.min,rules.max]"
                      max="2"
                      min="1"
                      dense
                      class="centered-input"
                      type="number"
                    />
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>

      <v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="px-10"
            text
            @click="goPrevious"
          >
            Go back
          </v-btn>
          <v-btn
            color="hrissecondary"
            class="px-10 white--text"          
            @click="goNext"
          >
            Proceed
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loading: false,
        leaveTypes: [],    
        rules: {
          required: value => !!value || 'Required.',     
          min: value => value >= 1 || 'Minimum number is 1',      
          max: value => value <= 2 || 'Max number is 2',      
        },  

      }
    },
    created () {
      this.loading = true
      this.loadData()
    },
    methods: {
      loadData () {
        this.$http.all([
          this.$api.hrisLeaveTypes().list(),
        ])
          .then(this.$http.spread((leaveTypes) => {
            this.leaveTypes = leaveTypes.data.map((leaveType) => {
              return {
                id: leaveType.id,
                name: leaveType.name,
                level: 1,
              }
            })

            this.loading = false
          }))
      },
      goNext () {
        if (this.$refs.creationApprovalLevelForm.validate()) {
          this.$emit('next-step')
        }
      },
      goPrevious () {
        this.$emit('previous-step')
      },
      getFormData () {
        return this.leaveTypes.map((leaveType) => {
          return {
            id: leaveType.id,
            level: leaveType.level,
          }
        })
      },
      
    },
  }
</script>

<style lang='css' scoped>
  ::v-deep .centered-input input {
    text-align: center
  }
</style>
